import { memo } from 'react';
import ReactHighlight from 'react-highlighter';

import styles from './index.module.scss';

interface HightLightProps {
  text: string;
  keywords: string;
}
const CustomHightLight = (props: HightLightProps) => {
  const { text, keywords } = props;

  return (
    <ReactHighlight search={keywords} matchClass={styles.match}>
      {text}
    </ReactHighlight>
  );
};

export const HightLight = memo(CustomHightLight);
